import React from "react";
//import PlanOverride from "../../../pages/LookUps/PlanOverride/PlanOverride";
//import BenefitMaxSchedule from "../../../pages/BenefitMaxSchedule/BenefitMaxSchedule";

const ConditionalLookup = ({
  screenNumber,
  params,
  receiveData,
  hideModal,
  sourceData,
}) => {
  console.log("source data", sourceData);
  const { aosAccumOvrdScdeType } = sourceData;
  const lookupScreen = screenNumber[aosAccumOvrdScdeType];
  const { lookupType, fieldMapping } = params;
  console.log("in local", lookupType, lookupScreen, params);
  switch (lookupScreen) {
    case "RCPLN018":
      return {
        /*         <PlanOverride
          params={fieldMapping.default}
          onSelect={receiveData}
          hideModal={hideModal}
          lookupType={lookupType}
        /> */
      };
    case "RCBSC005":
      return {
        /*<BenefitMaxSchedule
          params={fieldMapping.default}
          onSelect={receiveData}
          hideModal={hideModal}
          selectMode={true}
          lookupType={lookupType}
        />*/
      };
    default:
      return null;
  }
};
export default ConditionalLookup;
